module.exports = __webpack_public_path__ + "static/img/定制版.9122667a.webp";